// import { create } from 'zustand'
// import ApiClient from '../views/api/client'

// const apiClient = new ApiClient()

// export const useFileStore = create((set) => ({
//   familyFiles: [],
//   familyFolders: [],
//   createFolders: [],
//   createSubFolder: [],
//   folderFiles: [],
//   familySubfolder: [],
//   error: '',
//   loading: false,

//   fetchFamilyFiles: async (memberId) => {
//     set({ loading: true, error: '' })
//     try {
//       const response = await apiClient.fetchFamilyMemberFiles(memberId)
//       set((state) => ({
//         familyFiles: { ...state.familyFiles, [memberId]: response.data },
//         loading: false,
//       }))
//     } catch (err) {
//       console.error('Error fetching client files', err)
//       set({ error: err.response?.data?.detail, loading: false })
//     }
//   },
//   // fetch family member folder files
//   fetchFamilyFolderFiles: async (folderId, memberId) => {
//     set({ loading: true })
//     try {
//       const response = await apiClient.fetchFamilyFolderFiles(
//         folderId,
//         memberId
//       )
//       set((state) => ({
//         familyFolderFiles: { ...state.folderFiles, [folderId]: response.data },
//       }))
//     } catch (err) {
//       console.error('Error fetching family folder files', err)
//       set({ error: err.response?.data?.detail, loading: false })
//     }
//   },
//   // fetch family member folder
//   fetchFamilyFolders: async (memberId) => {
//     set({ loading: true, error: '' })
//     try {
//       const response = await apiClient.fetchFamilyMemberFolders(memberId)
//       set((state) => ({
//         familyFolders: { ...state.familyFolders, [memberId]: response.data },
//         loading: false,
//       }))
//     } catch (err) {
//       console.error('Error fetching client folders', err)
//       set({ error: err.response?.data?.detail, loading: false })
//     }
//   },
//   // fetch family member subfolders
//   fetchFamilySubfolders: async (folderId, memberId) => {
//     set({ loading: true, error: '' })
//     try {
//       const response = await apiClient.fetchFamilySubfolders(folderId, memberId)
//       set((state) => ({
//         familySubfolder: {
//           ...state.familySubfolder,
//           [memberId]: response.data,
//         },
//         loading: false,
//       }))
//     } catch (err) {
//       set({ error: err.response?.data?.detail, loading: false })
//     }
//   },

//   // create family member folders
//   createFamilyFolders: async (memberId, folderName) => {
//     set({ loading: true, error: '' })
//     try {
//       const response = await apiClient.createFamilyFolders(memberId, folderName)
//       set((state) => ({
//         createFolder: { ...state.createFolder, [memberId]: response.data },
//         loading: false,
//       }))
//     } catch (err) {
//       console.error('creating family member folder', err)
//       set({ error: err.response?.data?.detail, loading: false })
//     }
//   },
//   // Create family subfolders
//   createFamilySubFolders: async (memberId, folderId, folderName) => {
//     set({ loading: true, error: '' })
//     try {
//       const response = await apiClient.createFamilySubFolders(
//         memberId,
//         folderId,
//         folderName
//       )
//       set((state) => ({
//         createSubFolder: {
//           ...state.createSubFolder,
//           [memberId]: response.data,
//         },
//         loading: false,
//       }))
//     } catch (err) {
//       console.error('creating family member folder', err)
//       set({ error: err.response?.data?.detail, loading: false })
//     }
//   },

//   // uploadFile: async () => {
//   //   set({loading: true, error: ''})
//   //   try {
//   //     const response = await apiClient.uploadFamilyMemberFile(memberId)
//   //   }
//   // },

//   setError: (err) => set({ error: err }),
// }))

import { create } from 'zustand'
import ApiClient from '../views/api/client'

const apiClient = new ApiClient()

export const useFileStore = create((set) => ({
  fileUpload: {},
  fileFolderUpload: {},
  familyFiles: {},
  familyFolders: {},
  createFolder: {},
  createSubFolders: {},
  familyFolderFiles: {},
  familySubfolders: {},
  fileDelete: {},
  folderFileDelete: {},
  folderDelete: {},
  showUpdateModal: false,
  updateFolder: null,
  error: '',
  loading: false,

  // open update modal
  openUpdateModal: (folder) => {
    set({ showUpdateModal: true, updateFolder: folder })
  },
  // close update modal
  closeUpdateModal: () => {
    set({ showUpdateModal: false, updateFolder: null })
  },

  // ✅ fetch family member files
  fetchFamilyFiles: async (memberId) => {
    if (!memberId) {
      console.warn('❌ Skipping fetchFamilyFiles: memberId is missing')
      return
    }
    set({ loading: true, error: '' })
    try {
      const response = await apiClient.fetchFamilyMemberFiles(memberId)
      set((state) => ({
        familyFiles: { ...state.familyFiles, [memberId]: response.data },
        loading: false,
      }))
    } catch (err) {
      console.error('Error fetching client files', err)
      set({ error: err.response?.data?.detail || 'Error', loading: false })
    }
  },

  // ✅ fetch family member folder files
  fetchFamilyFolderFiles: async (memberId, folderId) => {
    if (!folderId || !memberId) {
      console.warn(
        '❌ Skipping fetchFamilyFolderFiles: missing folderId or memberId',
        folderId,
        memberId
      )
      return
    }
    set({ loading: true, error: '' })
    try {
      const response = await apiClient.fetchFamilyFolderFiles(
        memberId,
        folderId
      )
      set((state) => ({
        familyFolderFiles: {
          ...state.familyFolderFiles,
          [folderId]: response.data,
          // [memberId]: response.data,
        },
        loading: false,
      }))
    } catch (err) {
      console.error('Error fetching family folder files', err)
      set({ error: err.response?.data?.detail || 'Error', loading: false })
    }
  },

  // ✅ fetch family member folders
  fetchFamilyFolders: async (memberId) => {
    if (!memberId) {
      console.warn('❌ Skipping fetchFamilyFolders: memberId is missing')
      return
    }
    set({ loading: true, error: '' })
    try {
      const response = await apiClient.fetchFamilyMemberFolders(memberId)
      set((state) => ({
        familyFolders: { ...state.familyFolders, [memberId]: response.data },
        loading: false,
      }))
    } catch (err) {
      console.error('Error fetching client folders', err)
      set({ error: err.response?.data?.detail || 'Error', loading: false })
    }
  },

  // ✅ fetch family member subfolders
  fetchFamilySubfolders: async (memberId, folderId) => {
    if (!memberId || !folderId) {
      console.warn(
        '❌ Skipping fetchFamilySubfolders: missing folderId or memberId',
        memberId,
        folderId
      )
      return
    }
    set({ loading: true, error: '' })
    try {
      const response = await apiClient.fetchFamilySubfolders(memberId, folderId) // ✅ now awaited
      set((state) => ({
        familySubfolders: {
          ...state.familySubfolders,
          // [memberId]: response.data,
          [folderId]: response.data,
        },
        loading: false,
      }))
    } catch (err) {
      console.error('Error fetching subfolders', err)
      set({ error: err.response?.data?.detail || 'Error', loading: false })
    }
  },

  // ✅ create family member folders
  createFamilyFolders: async (memberId, folderName, fileCount) => {
    if (!memberId || !folderName || !fileCount) {
      console.warn(
        '❌ Skipping createFamilyFolders: missing memberId or folderName',
        memberId,
        folderName
      )
      return
    }
    set({ loading: true, error: '' })
    try {
      const response = await apiClient.createFamilyFolders(
        memberId,
        folderName,
        fileCount
      )
      set((state) => ({
        createFolder: { ...state.createFolder, [memberId]: response.data },
        loading: false,
      }))
    } catch (err) {
      console.error('Error creating family member folder', err)
      set({ error: err.response?.data?.detail || 'Error', loading: false })
    }
  },

  // ✅ create family subfolders
  createFamilySubFolders: async (memberId, folderId, folderName, fileCount) => {
    if (!memberId || !folderId || !folderName || !fileCount) {
      console.warn(
        '❌ Skipping createFamilySubFolders: missing params',
        memberId,
        folderId,
        folderName,
        fileCount
      )
      return
    }
    set({ loading: true, error: '' })
    try {
      const response = await apiClient.createFamilySubFolders(
        memberId,
        folderId,
        folderName,
        fileCount
      )
      set((state) => ({
        createSubFolder: {
          ...state.createSubFolder,
          [memberId]: response.data,
        },
        loading: false,
      }))
    } catch (err) {
      console.error('Error creating subfolder', err)
      set({ error: err.response?.data?.detail || 'Error', loading: false })
    }
  },
  uploadFileToFolder: async (memberId, folderId, file) => {
    set({ laoading: true })
    try {
      const response = await apiClient.uploadFileToFolder(
        memberId,
        folderId,
        file
      )
      set((state) => ({
        fileFolderUpload: {
          ...state.fileFolderUpload,
          [memberId]: response.data,
          [folderId]: response.data,
        },
        loading: false,
      }))
    } catch (err) {
      console.error('Error uploading file', err)
      set({ error: err.response?.data?.detail || 'Error', loading: false })
    }
  },
  uploadFile: async (memberId, file) => {
    set({ laoading: true })
    try {
      const response = await apiClient.uploadFile(memberId, file)
      set((state) => ({
        fileUpload: {
          ...state.fileUpload,
          [memberId]: response.data,
        },
        loading: false,
      }))
    } catch (err) {
      console.error('Error uploading file', err)
      set({ error: err.response?.data?.detail || 'Error', loading: false })
    }
  },
  deleteFile: async (memberId, fileId) => {
    set({ loading: true })
    try {
      const response = await apiClient.deleteFile(memberId, fileId)
      set((state) => ({
        fileDelete: {
          ...state.fileDelete,
          [memberId]: response.data,
        },
        laoding: false,
      }))
    } catch (err) {
      console.error('Error deleting file', err)
      set({
        error: err.response?.data?.detail || 'Error deleting folder file',
        loading: false,
      })
    }
  },
  deleteFolderFile: async (memberId, folderId, fileId) => {
    set({ loading: true })
    try {
      const response = await apiClient.deleteFolderFile(
        memberId,
        folderId,
        fileId
      )
      set((state) => ({
        folderFileDelete: {
          ...state.folderFileDelete,
          [memberId]: response.data,
        },
        loading: false,
      }))
    } catch (err) {
      console.error('Error deleting folder files', err)
      set({
        error: err.response?.data?.detail || 'Error deleting folder file',
        laoding: false,
      })
    }
  },
  deleteFolder: async (memberId, folderId) => {
    set({ loading: true })
    try {
      const response = await apiClient.deleteFolder(memberId, folderId)
      set((state) => ({
        folderDelete: {
          ...state.folderDelete,
          [folderId]: response.data,
        },
        loading: false,
      }))
    } catch (err) {
      console.error('Error deleting root folder', err)
      set({
        error: err.response?.data?.detail || 'Error deleting root folder',
        loading: false,
      })
    }
  },
  setError: (err) => set({ error: err }),
}))
